import { defineMessages } from 'react-intl';

export default defineMessages({
  intro: {
    defaultMessage: `Cool! I found you the best sport planets. But you can't leave without the proper space suit.`,
    id: 'app.fitting.intro.text'
  },
  gender: {
    defaultMessage: `Are you a boy or a girl?`,
    id: 'app.fitting.gender.text'
  },
  age: {
    defaultMessage: `Let's find the right size... How old are you?`,
    id: 'app.fitting.age.text'
  },
  ageLabel: {
    defaultMessage: `Age:`,
    id: 'app.fitting.age.label'
  },
  birthdayLabel: {
    defaultMessage: `Birthday:`,
    id: 'app.fitting.birthday.label'
  },
  size: {
    defaultMessage: `How tall are you compared to other {age}-year-olds?`,
    id: 'app.fitting.size'
  },
  ready: {
    defaultMessage: `Got it! This space suit will fit you perfectly. Let's go!`,
    id: 'app.fitting.ready.text'
  },
  finished: {
    defaultMessage: `Well Done Singapore private ! Go ask your  teacher/school what sports you're good in....`,
    id: 'app.fitting.finished.text'
  }
});



// WEBPACK FOOTER //
// ./src/containers/fitting/messages.js